import actions from '@/core/store/ata/documentos-ata/documentos/signatarios/actions'

export default {
	actions,
}
